import { _safeAdd, _safeSubtract } from "../PayslipHelper";
import { sumArray } from "../../../../../components/common/Converter";
export function _payslipCalculations({
  item,
  basicRate,
  checkCase,
  sumOfDeductions,
  sumOfContributions,
}) {
  const computedValues = {
    totalApEarned: 0,
    totalEarned: 0,
    totalBasic: 0,
    totalPeraAda: 0,
    totalBasicEarned: 0,
    absencesIncurred: 0,
    latesUtIncurred: 0,
    netPay: 0,
  };

  const displayValues = {
    overpayment: 0,
    flagRaising: 0,
    peraAda: 0,
    tax: 0,
    deductionDueToLeavesTardy: 0,
    overpaymentBasic: 0,
    overpaymentPeraAda: 0,
    deductionPeraAda: 0,
    absencesDays: 0,
    basicRate: 0,
    absencesMins: 0,
  };

  //BASIC PAY - GENERAL PAYROLL
  if (checkCase("isBasicGeneral")) {
    displayValues.peraAda = item?.peraAda;
    displayValues.basicRate = basicRate;
    const totalDeductions = _safeAdd(sumOfDeductions, sumOfContributions);

    computedValues.totalEarned = _safeAdd(basicRate, item?.peraAda);
    computedValues.netPay = _safeSubtract(
      computedValues.totalEarned,
      totalDeductions
    );
    return { computedValues, displayValues };
  }
  //BASIC - ADDENDUM PAYROLL
  else if (checkCase("isBasicAddendum")) {
    displayValues.basicRate = basicRate;
    displayValues.deductionDueToLeavesTardy = item?.deductionDueToLeavesTardy;
    displayValues.overpaymentBasic = item?.overpaymentBasic;
    displayValues.overpaymentPeraAda = item?.overpaymentPeraAda;
    displayValues.peraAda = item?.peraAda;
    displayValues.deductionPeraAda = item?.deductionPeraAda;

    const totalDueToLeaves = _safeAdd(
      item?.deductionDueToLeavesTardy,
      item?.overpaymentBasic
    );

    const totalDueToPera = _safeAdd(
      item?.deductionPeraAda,
      item?.overpaymentPeraAda
    );

    computedValues.totalBasic = _safeSubtract(basicRate, totalDueToLeaves);
    computedValues.totalPeraAda = _safeSubtract(item?.peraAda, totalDueToPera);
    computedValues.totalBasicEarned = _safeAdd(
      computedValues.totalBasic,
      computedValues.totalPeraAda
    );
    computedValues.netPay = _safeSubtract(
      computedValues.totalBasicEarned,
      sumOfDeductions,
      sumOfContributions
    );

    return { computedValues, displayValues };
  }
  //BASIC - JO - SALARY
  else if (checkCase("isBasicJoSalary")) {
    displayValues.basicRate = basicRate;
    displayValues.absencesDays = item?.absencesDays;
    displayValues.absencesMins = item?.absencesMins;
    displayValues.overpayment = item?.overpayment;
    displayValues.flagRaising = item?.flagRaising;
    displayValues.tax = item?.totalTax;

    const totalDeductionsDue = _safeAdd(
      item?.absencesDays,
      item?.absencesMins,
      item?.overpayment,
      item?.flagRaising,
      item?.totalTax,
      sumOfDeductions,
      sumOfContributions
    );

    computedValues.netPay = _safeSubtract(basicRate, totalDeductionsDue);
  }
  //BASIC - ADDENDUM BACK-PAY PAYROLL
  else if (checkCase("isBasicBackpay")) {
    const dueToLeavesTardy = sumArray(item?.deductionDueToLeavesTardy);
    const overpaymentBasic = sumArray(item?.overpaymentBasic);
    const overpaymentPeraAda = sumArray(item?.overpaymentPeraAda);
    const deductionPeraAda = sumArray(item?.deductionPeraAda);
    const basicRateForBackPay = sumArray(item?.basicRateForBackPay);
    const peraAdaForBackPay = sumArray(item?.peraAdaForBackPay);
    const tax = sumArray(item?.tax);
    displayValues.basicRate = basicRateForBackPay;
    displayValues.peraAda = peraAdaForBackPay;

    displayValues.deductionDueToLeavesTardy = dueToLeavesTardy;
    displayValues.overpaymentBasic = overpaymentBasic;
    displayValues.overpaymentPeraAda = overpaymentPeraAda;
    displayValues.deductionPeraAda = deductionPeraAda;

    const totalDueToLeaves = _safeAdd(dueToLeavesTardy, overpaymentBasic);
    const totalDueToPera = _safeAdd(deductionPeraAda, overpaymentPeraAda);

    computedValues.totalBasic = _safeSubtract(
      basicRateForBackPay,
      totalDueToLeaves
    );
    computedValues.totalPeraAda = _safeSubtract(
      peraAdaForBackPay,
      totalDueToPera
    );
    computedValues.totalBasicEarned = _safeAdd(
      computedValues.totalBasic,
      computedValues.totalPeraAda
    );

    computedValues.netPay = _safeSubtract(
      computedValues.totalBasicEarned,
      tax,
      sumOfContributions,
      sumOfDeductions
    );
  }
  //BASIC - JO - ADDENDUM PAYROLL
  else if (checkCase("isBasicJoAddendum")) {
    displayValues.basicRate = basicRate;
    const totalTax = sumArray(item?.totalTax);
    const earnedForThePeriod = sumArray(item?.earnedForThePeriod);

    computedValues.absencesIncurred = sumArray(item?.absencesMins);
    computedValues.latesUtIncurred = sumArray(item?.absencesDays);
    displayValues.tax = sumArray(item?.totalTax);
    displayValues.overpayment = sumArray(item?.overpayment);
    displayValues.flagRaising = sumArray(item?.flagRaising);

    computedValues.netPay = _safeSubtract(
      earnedForThePeriod,
      totalTax,
      sumOfDeductions
    );
  }
  //AUGMENTATION PAY - GENERAL/NEWLY HIRED PAYROLL
  else if (checkCase("isApGeneralNewly")) {
    displayValues.overpayment = item?.overpayment;
    displayValues.flagRaising = item?.flagRaising;
    displayValues.tax = item?.tax;

    computedValues.totalApEarned = _safeAdd(
      item?.proratedApRate,
      item?.earnedAirportAug
    );
    computedValues.absencesIncurred = _safeAdd(
      item?.absencesLeavesCurrAss,
      item?.absencesLeavesAirportAss
    );
    computedValues.latesUtIncurred = _safeAdd(
      item?.latesUTMinsCurrent,
      item?.latesUTMinsAirportAug
    );
    const totalDeductionsDue = _safeAdd(
      computedValues.absencesIncurred,
      computedValues.latesUtIncurred,
      item?.overpayment,
      item?.flagRaising,
      item?.tax,
      sumOfDeductions,
      sumOfContributions
    );
    computedValues.totalEarned = computedValues?.totalApEarned;
    computedValues.netPay = _safeSubtract(
      computedValues.totalEarned,
      totalDeductionsDue
    );

    return { computedValues, displayValues };
  }
  //AP BACK-PAY
  else if (checkCase("isApBackPay")) {
    const proratedApRate = sumArray(item?.proratedApRate);
    const airportAugRate = sumArray(item?.amountEarnedAirportAugmentation);
    const absencesPresent = sumArray(item?.absPresentAss_2);
    const absencesAirport = sumArray(item?.absAirportAss_2);
    const latesUtPresent = sumArray(item?.lateUTperMinutePresentAss_2);
    const latesUtAirport = sumArray(item?.lateUTperMinuteAirportAss_2);

    computedValues.absencesIncurred = _safeAdd(
      absencesPresent,
      absencesAirport
    );
    computedValues.latesUtIncurred = _safeAdd(latesUtPresent, latesUtAirport);
    displayValues.overpayment = sumArray(item?.overpayment);
    displayValues.flagRaising = sumArray(item?.flagRaising);
    displayValues.tax = sumArray(item?.tax);

    computedValues.totalApEarned = _safeAdd(proratedApRate, airportAugRate);
    computedValues.totalEarned = computedValues.totalApEarned;
    computedValues.netPay = _safeSubtract(
      computedValues.totalApEarned,
      computedValues.absencesIncurred,
      computedValues.latesUtIncurred,
      displayValues.overpayment,
      displayValues.flagRaising,
      displayValues.tax,
      sumOfDeductions
    );
  }

  return {
    computedValues,
    displayValues,
  };
}
